import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/components/Herder/contentHerder.vue";
import Home from "@/views/home";
import Login from "@/views/login";
import Register from "@/views/register";
import ForgotPassword from "@/views/forgotPassword";
import Commerce from "@/views/commerce";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    component: Home,
    meta: { title: "首页", eTitle: "Home" },
  },
  {
    path: "/commerce",
    name: "commerce",
    component: Commerce,
    meta: { title: "商务合作", eTitle: "Commerce" },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: { title: "登录", eTitle: "Login" },
  },
  {
    path: "/register",
    name: "register",
    component: Register,
    meta: { title: "注册", eTitle: "Register" },
  },
  {
    path: "/forgotPassword",
    name: "forgotPassword",
    component: ForgotPassword,
    meta: { title: "忘记密码", eTitle: "Forgot password" },
  },

  {
    path: "/module",
    component: Layout,
    redirect: "/module/home",
    children: [
      {
        path: "home",
        component: () => import("@/views/homePage"),
        meta: { title: "首页", eTitle: "Home" },
      },
      {
        path: "reward",
        component: () => import("@/views/reward"),
        meta: { title: "奖励", eTitle: "reward" },
      },
      {
        path: "latestNew",
        component: () => import("@/views/LatestNew"),
        meta: { title: "最新公告", eTitle: "LatestNew" },
      },
      {
        path: "allNews",
        component: () => import("@/views/allNews"),
        meta: { title: "全部公告", eTitle: "allNews" },
      },
      {
        path: "allNewDetails",
        component: () => import("@/views/allNewDetails"),
        meta: { title: "公告详情", eTitle: "allNewDetails" },
      },

      {
        path: "taskRecord",
        component: () => import("@/views/taskRecord"),
        meta: { title: "任务记录", eTitle: "Task record" },
      },
      {
        path: "redemptionHistory",
        component: () => import("@/views/redemptionHistory"),
        meta: { title: "兑换历史", eTitle: "Redemption history" },
      },
      {
        path: "notice",
        component: () => import("@/views/notice"),
        meta: { title: "我的消息", eTitle: "My message" },
      },
      {
        path: "credits",
        component: () => import("@/views/credits"),
        meta: { title: "信用值历史", eTitle: "Credits history" },
      },
      {
        path: "goldHistory",
        component: () => import("@/views/goldHistory"),
        meta: { title: "金币明细", eTitle: "History of Gold Coins" },
      },
      {
        path: "account",
        component: () => import("@/views/account"),
        meta: { title: "账户设置", eTitle: "Account settings" },
      },
      {
        path: "invite",
        component: () => import("@/views/invite"),
        meta: { title: "我的邀请", eTitle: "My invitation" },
      },
      {
        path: "creditValue",
        component: () => import("@/views/creditValue"),
        meta: { title: "我的信用值", eTitle: "My credit value" },
      },
      {
        path: "task",
        component: () => import("@/views/task"),
        meta: { title: "任务", eTitle: "task" },
      },
      {
        path: "taskDetails",
        component: () => import("@/views/taskDetails"),
        meta: { title: "任务详情", eTitle: "task details" },
      },
      {
        path: "exchange",
        component: () => import("@/views/exchange"),
        meta: { title: "兑换", eTitle: "exchange" },
      },
      {
        path: "activity",
        component: () => import("@/views/activity"),
        meta: { title: "活动", eTitle: "activity" },
      },
      {
        path: "help",
        component: () => import("@/views/help"),
        meta: { title: "帮助", eTitle: "help" },
      },
    ],
  },

  {
    path: "/mobile",
    name: "mobile",
    redirect: "/mobile/login",
  },
  {
    path: "/mobile/login",
    name: "mobilelogin",
    component: () => import("@/views/mobile/login.vue"),
    meta: { title: "登录", eTitle: "login" },
  },
  {
    path: "/mobile/forgotPassword",
    name: "mobileforgotPassword",
    component: () => import("@/views/mobile/forgotPassword.vue"),
    meta: { title: "重置密码", eTitle: "forgotPassword" },
  },
  {
    path: "/mobile/register",
    name: "register",
    component: () => import("@/views/mobile/register.vue"),
    meta: { title: "账号注册", eTitle: "register" },
  },
  {
    path: "/mobile/phoneLogin",
    name: "mobilephoneLogin",
    component: () => import("@/views/mobile/phoneLogin.vue"),
    meta: { title: "快捷登录", eTitle: "phoneLogin" },
  },
  {
    path: "/mobile/home",
    name: "mobilehome",
    component: () => import("@/views/mobile/home.vue"),
    meta: { title: "首页", eTitle: "home" },
  },
  {
    path: "/mobile/task",
    name: "mobiletask",
    component: () => import("@/views/mobile/task.vue"),
    meta: { title: "任务", eTitle: "task" },
  },
  {
    path: "/mobile/taskDetails",
    name: "mobiletaskDetails",
    component: () => import("@/views/mobile/taskDetails.vue"),
    meta: { title: "任务详情", eTitle: "task Details" },
  },
  {
    path: "/mobile/exchange",
    name: "mobileexchange",
    component: () => import("@/views/mobile/exchange.vue"),
    meta: { title: "兑换", eTitle: "Exchange" },
  },
  {
    path: "/mobile/my",
    name: "mobilemy",
    component: () => import("@/views/mobile/my.vue"),
    meta: { title: "我的", eTitle: "my" },
  },
  {
    path: "/mobile/dailyTasks",
    name: "mobiledailyTasks",
    component: () => import("@/views/mobile/dailyTasks.vue"),
    meta: { title: "每日任务", eTitle: "dailyTasks" },
  },
  {
    path: "/mobile/coupon",
    name: "mobilecoupon",
    component: () => import("@/views/mobile/coupon.vue"),
    meta: { title: "卡券专区", eTitle: "coupon" },
  },
  {
    path: "/mobile/invite",
    name: "mobileinvite",
    component: () => import("@/views/mobile/invite.vue"),
    meta: { title: "邀请好友", eTitle: "invite" },
  },
  {
    path: "/mobile/signIn",
    name: "mobilesignIn",
    component: () => import("@/views/mobile/signIn.vue"),
    meta: { title: "签到", eTitle: "signIn" },
  },
  {
    path: "/mobile/prizeDetails",
    name: "mobileprizeDetails",
    component: () => import("@/views/mobile/prizeDetails.vue"),
    meta: { title: "奖品详情", eTitle: "prizeDetails" },
  },
  {
    path: "/mobile/exchangeRecords",
    name: "mobileexchangeRecords",
    component: () => import("@/views/mobile/exchangeRecords.vue"),
    meta: { title: "兑换记录", eTitle: "exchangeRecords" },
  },
  {
    path: "/mobile/creditDetails",
    name: "mobilecreditDetails",
    component: () => import("@/views/mobile/creditDetails.vue"),
    meta: { title: "信用明细", eTitle: "creditDetails" },
  },
  {
    path: "/mobile/taskRecord",
    name: "mobiletaskRecord",
    component: () => import("@/views/mobile/taskRecord.vue"),
    meta: { title: "任务列表", eTitle: "taskRecord" },
  },
  {
    path: "/mobile/problem",
    name: "mobileproblem",
    component: () => import("@/views/mobile/problem.vue"),
    meta: { title: "常见问题", eTitle: "problem" },
  },
  {
    path: "/mobile/aboutUs",
    name: "mobileaboutUs",
    component: () => import("@/views/mobile/aboutUs.vue"),
    meta: { title: "关于我们", eTitle: "aboutUs" },
  },
  {
    path: "/mobile/privacy",
    name: "mobileprivacy",
    component: () => import("@/views/mobile/privacy.vue"),
    meta: { title: "隐私协议", eTitle: "privacy" },
  },
  {
    path: "/mobile/personalData",
    name: "mobilepersonalData",
    component: () => import("@/views/mobile/personalData.vue"),
    meta: { title: "个人资料", eTitle: "personalData" },
  },
  {
    path: "/mobile/accountSettings",
    name: "mobileaccountSettings",
    component: () => import("@/views/mobile/accountSettings.vue"),
    meta: { title: "账户设置", eTitle: "accountSettings" },
  },

  {
    path: "/mobile/updateSettings",
    name: "mobileupdateSettings",
    component: () => import("@/views/mobile/updateSettings.vue"),
    meta: { title: "设置", eTitle: "updateSettings" },
  },
  {
    path: "/mobile/allNews",
    name: "mobileallNews",
    component: () => import("@/views/mobile/allNews.vue"),
    meta: { title: "全部公告", eTitle: "allNews" },
  },
  {
    path: "/mobile/allNewDetails",
    name: "mobileallNewDetails",
    component: () => import("@/views/mobile/allNewDetails.vue"),
    meta: { title: "公告详情", eTitle: "allNewDetails" },
  },
  {
    path: "/mobile/myMessages",
    name: "mobilemyMessages",
    component: () => import("@/views/mobile/myMessages.vue"),
    meta: { title: "我的消息", eTitle: "myMessages" },
  },
  {
    path: "/mobile/reward",
    name: "mobilereward",
    component: () => import("@/views/mobile/reward.vue"),
    meta: { title: "奖励", eTitle: "reward" },
  },
  {
    path: "/mobile/landingPage",
    name: "mobilelandingPage",
    component: () => import("@/views/mobile/landingPage.vue"),
    meta: { title: "微信绑定", eTitle: "WeChat Binding" },
  },
  {
    path: "/mobile/clickView",
    name: "mobileclickView",
    component: () => import("@/views/mobile/clickView.vue"),
    meta: { title: "查看绑定", eTitle: "clickView" },
  },
  {
    path: "/mobile/bind",
    name: "mobilebind",
    component: () => import("@/views/mobile/bind.vue"),
    meta: { title: "立即绑定", eTitle: "Bind" },
  },

  // 404 页面 - 必须放在最后
  {
    path: "*",
    name: "NotFound",
    // 这里先不写 component，或者写一个极轻量的空白组件
    component: { template: "<div></div>" },
    beforeEnter: (to, from, next) => {
      // 如果是你希望“不拦截”的特殊路径
      if (to.path === "/p/surveydone/index" || to.path === "/.well-known/" || to.path === "/MP_verify_LRGrkX9bLeIVfKZL.txt") {
        // 直接放行，并且渲染上面的空白 div，不显示 404
        next();
      } else {
        // 如果是其他任意不存在的路径，动态跳转到真正的 404 页面
        next({ name: "NotFoundPage", replace: true });
      }
    },
  },
  // 真正的 404 页面路由（需要给它一个具体的 name，方便上面跳转）
  {
    path: "/404",
    name: "NotFoundPage",
    component: () => import("@/views/404.vue"),
    meta: { title: "页面未找到", eTitle: "Page Not Found" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

export default router;
